import SafeHtml from "../../content/SafeHtml";
// import { Link } from "react-router-dom";
// import withFirebaseCollection from "../HOK/withFirebaseCollection";
// import css from "./userCabinet.module.css";

// const BlockMaister = ({ data, userBd }) => {
//   return (
//     <div className={css.readerUserWrap}>
//       {data.length > 0 && (
//         <div className={css.readerUserWrapSmall}>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href="https://forms.gle/L3pAwFmuMGCR24ZY6"
//               target="_blanck"
//             >
//               Анкета Автора/ перехід на гугл-форму/ в будь-який момент Ви можете
//               її редагувати
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].updateData}</p>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href="https://forms.gle/eDYkfEDi6tk4Fhjj6"
//               target="_blanck"
//             >
//               Анкета майстра (художника, типографіка, дизайнера, редактора,
//               психолога, наукового редактора, критика) для публікації сторінки
//               на сайті/ перехід на гугл-форму/ в будь-який момент Ви можете її
//               редагувати
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].anketMaister}</p>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href="mailto:vredaktor@chasmaistriv.com.ua"
//             >
//               vredaktor@chasmaistriv.com.ua
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].personalManager}</p>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href="mailto:origin@chasmaistriv.com.ua"
//             >
//               Подати рукопис на розгляд/перехід на email
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].submitManuscript}</p>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href="https://forms.gle/MuM2M5giHzKQMWjp9"
//               target="_blanck"
//             >
//               Публікація рукопису на сайті з метою дослідження/перехід до
//               гугл-форми з анкетою рукопису
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].manuscript}</p>
//           <h1 className={css.aboutCompanyH1}>
//             Ви можете допомогти авторам/до каталогу рукописів
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].helpAutor}</p>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href={`${data[0].opikunForm}`}
//               target="_blanck"
//             >
//               Подати заявку до опікунської ради
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].opicunText}</p>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href={`${data[0].searchAutor}`}
//               target="_blanck"
//             >
//               Шукаємо автора (перехід на гугл-форму з анкетою)
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].searchAutorText}</p>
//           <h1 className={css.aboutCompanyH1}>
//             <a
//               className={css.aboutCompanyH1}
//               href="https://t.me/chas_maistriv"
//               target="_blanck"
//             >
//               Підписатися на телеграм-канал "Час майстрів"
//             </a>
//           </h1>
//           <p className={css.paragInWrapBig}>{data[0].tgChanelText}</p>
//         </div>
//       )}
//     </div>
//   );
// };
// export default withFirebaseCollection("infoBusiness")(BlockMaister);
import { Link } from "react-router-dom";
import css from "./userCabinet.module.css";
import useContentDoc from "../../hooks/useContentDoc";

const BlockMaister = () => {
  // тягнемо документ siteContent/blockMaister
  const { data: c } = useContentDoc("siteContent", "blockMaister");

  if (!c || c.enabled === false) return null;

  return (
    <div className={css.readerUserWrap}>
      <div className={css.readerUserWrapSmall}>
        {/* Анкета автора */}
        {c.authorForm?.url && c.authorForm?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.authorForm.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.authorForm.label}
            </a>
          </h1>
        )}

        {/* Оновіть дані */}
        {c.updateDataHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.updateDataHtml}
          />
        )}

        {/* Анкета майстра */}
        {c.masterForm?.url && c.masterForm?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.masterForm.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.masterForm.label}
            </a>
          </h1>
        )}
        {c.anketMaisterHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.anketMaisterHtml}
          />
        )}

        {/* Email редактора */}
        {c.editorEmail && (
          <h1 className={css.aboutCompanyH1}>
            <a className={css.aboutCompanyH1} href={`mailto:${c.editorEmail}`}>
              {c.editorEmail}
            </a>
          </h1>
        )}
        {c.personalManagerHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.personalManagerHtml}
          />
        )}

        {/* Подати рукопис (mailto) */}
        {c.submitManuscript?.label && c.submitManuscript?.mailto && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={`mailto:${c.submitManuscript.mailto}`}
            >
              {c.submitManuscript.label}
            </a>
          </h1>
        )}

        {/* Форма рукопису */}
        {c.manuscriptForm?.url && c.manuscriptForm?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.manuscriptForm.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.manuscriptForm.label}
            </a>
          </h1>
        )}
        {c.manuscriptHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.manuscriptHtml}
          />
        )}

        {/* Допомогти авторам */}
        {c.helpAutorTitle && (
          <h1 className={css.aboutCompanyH1}>{c.helpAutorTitle}</h1>
        )}
        {c.helpAutorHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.helpAutorHtml}
          />
        )}

        {/* Опікунська рада */}
        {c.opikunForm?.url && c.opikunForm?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.opikunForm.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.opikunForm.label}
            </a>
          </h1>
        )}
        {c.opicunTextHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.opicunTextHtml}
          />
        )}

        {/* Шукаємо автора */}
        {c.searchAutor?.url && c.searchAutor?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.searchAutor.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.searchAutor.label}
            </a>
          </h1>
        )}
        {c.searchAutorTextHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.searchAutorTextHtml}
          />
        )}

        {/* Telegram */}
        {c.tgChannel?.url && c.tgChannel?.label && (
          <h1 className={css.aboutCompanyH1}>
            <a
              className={css.aboutCompanyH1}
              href={c.tgChannel.url}
              target="_blank"
              rel="noreferrer noopener"
            >
              {c.tgChannel.label}
            </a>
          </h1>
        )}
        {c.tgChanelTextHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.tgChanelTextHtml}
          />
        )}
        {/* Додатковий заголовок (з посиланням) */}
        {c.extraHeading?.label && (
          <h1 className={css.aboutCompanyH1}>
            {c.extraHeading?.url ? (
              <a
                className={css.aboutCompanyH1}
                href={c.extraHeading.url}
                target="_blank"
                rel="noreferrer noopener"
              >
                {c.extraHeading.label}
              </a>
            ) : (
              c.extraHeading.label
            )}
          </h1>
        )}

        {/* Додатковий HTML-блок */}
        {c.extraSectionHtml && (
          <SafeHtml
            className={css.paragInWrapBig}
            html={c.extraSectionHtml}
          />
        )}
      </div>
    </div>
  );
};

export default BlockMaister;
